<div class="row d-flex justify-content-center">
  <mat-label>{{labelChamp}} </mat-label>
  <button mat-raised-button class="col-xs-12 col-md-12 col-lg-12" color="primary"  (press)="onPress($event)" (pressUp)="onPressUp($event)" (click)="pressOne()">
    <label class="label-increment-decrement">+</label>
  </button>
  <input  mat-input type="text" placeholder="Année" class="col-xs-12 col-md-12 col-lg-12 form-control" [formControl]="numberField" [value]="debutcount" (change)="formTONumber()">
  <button mat-raised-button class="col-xs-12 col-md-12 col-lg-12" color="primary" (press)="onPressDown($event)" (pressUp)="onPressUp($event)"  (click)="pressDownOne()">
    <label class="label-increment-decrement">-</label>
  </button>
</div>

